import {TableCell, TableRow} from "@material-ui/core";
import _ from "lodash";
import React from "react";
import {makeStyles} from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  inheritFontWeight: {
    fontWeight: 'inherit',
  }
}));


const keys = [
  { id: 'ria_investor_crd_id', name: 'Entity CRD Id' },
  { id: 'owner_type', name: 'Owner Type' },
  { id: 'contact_status', name: 'Contact Status' },
  { id: 'month', name: 'Month' },
  { id: 'year', name: 'Year' },
  { id: 'ownership_code', name: 'Ownership Code' },
  { id: 'ownership_percentage', name: 'Ownership Perecentage' },
  { id: 'control_person', name: 'Control Person' },
  { id: 'owner_public_company', name: 'owner_public_company' },
]

const EntityOwnerDataRow = (props) => {
  const {entityOwners} = props;
  const classes = useStyles();
  return (
    entityOwners.map(((entityOwner, index) =>
        <TableRow hover key={`row-history-${index}`}>
          {keys.map(((key) =>
              <TableCell key={`${key.name}-row-history-data-${index}`} className={classes.inheritFontWeight}>
                {_.isNil(entityOwner[key.id]) ? '' : `${entityOwner[key.id]}`}
              </TableCell>
          ))}
        </TableRow>
    ))
  )
}

export default EntityOwnerDataRow;